import React from "react";
import { Fade } from "react-reveal";
import ListTile from "../../common/ListTile";
import {
  DescTitle,
  ExperienceTileBox,
  ImageContainer,
  Title,
  SubTitle,
} from "../experience/experience_element";

const ExperienceTile = ({ title, subtitle, desc, img, index }) => {
  return (
    <Fade bottom duration={index * 500}>
      <ExperienceTileBox>
        <ListTile
          leading={
            <ImageContainer
              src={require("../../assets/images/" + img)}
              alt={title}
            />
          }
          title={<Title>{title}</Title>}
          subtitle={<SubTitle>{subtitle}</SubTitle>}
          desc={<DescTitle>{desc}</DescTitle>}
        ></ListTile>
      </ExperienceTileBox>
    </Fade>
  );
};

export default ExperienceTile;
